import { Module } from '../module';
import { Controller } from './sp-qr.controller';

Module.component('spQr', {
    bindings: {
        encoded: '<',
        loadQrData: '&',
    },
    controller: Controller,
    templateUrl: require('./sp-qr.html'),
});



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/sp-qr/sp-qr.component.js